function LogOut() {
  return (
    <p style={{ textAlign: "center", marginTop: "10%" }}>
      You have been logged out. Thanks for using Editori. Please close this
      page.
    </p>
  );
}
export default LogOut;
